import React from 'react';

import {PANELMANAGER_SET_PANEL_INFO} from '../../constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import setPanelTitle from '~/frontend/src/actions/panelManager/setPanelTitle';
import setPanelIcon from '~/frontend/src/actions/panelManager/setPanelIcon';
import setPanelTooltip from '~/frontend/src/actions/panelManager/setPanelTooltip';
import setPanelDirty from '~/frontend/src/actions/panelManager/setPanelDirty';
import setPanelInvalid from '~/frontend/src/actions/panelManager/setPanelInvalid';
import setPanelPath from '~/frontend/src/actions/panelManager/setPanelPath';

export type SetPanelInfoAction = {
    type : typeof PANELMANAGER_SET_PANEL_INFO;
    panelKey : string;
    info : {
        title? : string;
        icon? : string;
        tooltip? : React.ReactNode;
        dirty? : boolean;
        invalid? : boolean;
        path? : string;
    };
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {SetPanelInfoAction['info']} info
 *
 * @return {SetPanelInfoAction}
 */
const setPanelInfo = ( panelKey : string, info : SetPanelInfoAction[ 'info' ] ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: PANELMANAGER_SET_PANEL_INFO,
        panelKey,
        info
    } );

    if ( info.title !== undefined ) {
        dispatch( setPanelTitle( panelKey, info.title ) );
    }

    if ( info.icon !== undefined ) {
        dispatch( setPanelIcon( panelKey, info.icon ) );
    }

    dispatch( setPanelTooltip( panelKey, info.tooltip ) );

    if ( info.dirty !== undefined ) {
        dispatch( setPanelDirty( panelKey, info.dirty ) );
    }

    if ( info.invalid !== undefined ) {
        dispatch( setPanelInvalid( panelKey, info.invalid ) );
    }

    if ( info.path !== undefined ) {
        dispatch( setPanelPath( panelKey, info.path ) );
    }
}
export type SetPanelInfo = typeof setPanelInfo;

export default setPanelInfo;
